export default "__VITE_ASSET__dea46fbb__"